import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { DoctorCatalogEntity } from '../../../../entities/mdqx/doctor/doctor-catalog.entity';
import { DoctorCatalogActions } from '../../../actions/mdqx/doctor/doctor-catalog.actions';

export const DOCTOR_CATALOG_FEATURE_KEY = 'doctorCatalog';

export interface DoctorCatalogState extends EntityState<DoctorCatalogEntity> {
    fetched: boolean;
    // latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<DoctorCatalogEntity>({
    selectId: (Entity) => Entity.Id,
    sortComparer: (a, b) => a.Name.localeCompare(b.Name),
});

const initialState: DoctorCatalogState = adapter.getInitialState({
    fetched: false,
    // latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const doctorCatalogReducer = createReducer(
    initialState,
    on(DoctorCatalogActions.loadSuccess, (state, { Payload }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
        }),
    ),
    on(DoctorCatalogActions.createSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
        }),
    ),
    on(DoctorCatalogActions.changeSuccess, (state, { Payload }) =>
        adapter.setOne(Payload, {
            ...state,
        }),
    ),
    on(DoctorCatalogActions.deleteSuccess, (state, { Payload }) =>
        adapter.removeOne(Payload, {
            ...state,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllDoctorCatalog = selectAll;
export const selectDoctorCatalogEntities = selectEntities;

export const selectDoctorCatalogFetched = (state: DoctorCatalogState) => state.fetched;
// export const selectDoctorCatalogLatestUpdatedAt = (state: DoctorCatalogState) => state.latestUpdatedAt;
